import { Card, Link as ComponentLibraryLink, Icon } from '@ps/isp-web-component-library';
import { ChevronSmallRight } from '@ps/isp-web-component-library/icons/ChevronSmallRight';
import { Link, Translation } from '@ps/web-shared-components';
import { landingPageEventTypeIds } from '@ps/web-sports-config';
import { useSelector } from 'react-redux';

import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { ExpandablePanel, Title } from '@swf/sports/components/ExpandablePanel/ExpandablePanel';
import GroupedTemplatePanels from '@swf/sports/components/GroupedTemplatePanels/GroupedTemplatePanels';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { useSportsHomePageWidget } from '../../model';

import { TXTWCL_All_Competitions, TXTWCL_Upcoming___N0 } from './UpcomingEvents.messages.json';

export const UpcomingEvents: React.FC = () => {
  const { widgetSelect } = useSportsHomePageWidget();
  const hasUpcomingEvents = useSelector(widgetSelect.hasUpcomingEvents);
  const upcomingEvents = useSelector(widgetSelect.upcomingEvents);
  const eventType = useSelector(widgetSelect.upcomingEventType);
  const events = useSelector(widgetSelect.events);
  const isEventTypeLandingPage = useSelector((state: RootState) =>
    select.sports.isEventTypeLandingPage(state, {
      eventTypeId: eventType?.eventTypeId,
      landingPageEventTypeIds
    })
  );

  if (!hasUpcomingEvents || !upcomingEvents || !eventType || !Object.keys(events).length) {
    return null;
  }

  const { eventTypeId, eventTypeSlug, name } = eventType;

  return (
    <SportsComponent name="Sports Home Upcoming Events Component">
      <Vary by={[Header.TimeZone]} />
      <ExpandablePanel
        title={
          <Title isNested>
            <Translation {...TXTWCL_Upcoming___N0} values={{ 0: name }} />
          </Title>
        }
        isNested
      >
        <GroupedTemplatePanels groupedOn="COMPETITION" groups={upcomingEvents} isNested />
        <Card isPadded>
          <ComponentLibraryLink variant="secondary" asChild isButtonLink>
            <Link
              alias={isEventTypeLandingPage ? 'sportsCompetitions' : 'sportsSport'}
              values={{
                eventTypeId,
                eventTypeSlug
              }}
            >
              <Translation {...TXTWCL_All_Competitions} />
              <Icon icon={ChevronSmallRight} size="x1" />
            </Link>
          </ComponentLibraryLink>
        </Card>
      </ExpandablePanel>
    </SportsComponent>
  );
};
